import React, { useState, useEffect } from 'react';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { api } from './api';
import './App.css';

export default function App() {
  const params = new URLSearchParams(window.location.search);
  const urlSubAccountId = params.get('sub_account_id') || params.get('locationId');
  const justConnected = params.get('connected') === 'true';
  const oauthError = params.get('oauth_error');

  // If URL has sub_account_id, persist it and use it directly
  // If not, check localStorage — if still nothing, show login
  let subAccountId = urlSubAccountId;
  if (subAccountId) {
    localStorage.setItem('rfs_fleet_sub_account_id', subAccountId);
  } else {
    subAccountId = localStorage.getItem('rfs_fleet_sub_account_id');
  }

  const [connectedProvider, setConnectedProvider] = useState(null);
  const [loading, setLoading] = useState(!!subAccountId); // only load if we have an ID
  const [showLogin, setShowLogin] = useState(!subAccountId);

  useEffect(() => {
    if (!subAccountId) return;
    api.getStatus(subAccountId)
      .then(({ connected, provider }) => {
        if (connected) {
          setConnectedProvider(provider);
        } else if (justConnected) {
          setConnectedProvider('ridedog');
        }
      })
      .catch(() => {
        if (justConnected) setConnectedProvider('ridedog');
      })
      .finally(() => setLoading(false));
  }, [subAccountId, justConnected]);

  function handleLoginSuccess(id) {
    localStorage.setItem('rfs_fleet_sub_account_id', id);
    // Redirect with the sub_account_id in the URL so the app loads normally
    window.location.href = `/?sub_account_id=${encodeURIComponent(id)}`;
  }

  function handleLogout() {
    localStorage.removeItem('rfs_fleet_sub_account_id');
    window.location.href = '/login';
  }

  if (showLogin) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Dashboard
      subAccountId={subAccountId}
      connectedProvider={connectedProvider}
      oauthError={oauthError}
      onProviderConnected={(provider) => setConnectedProvider(provider)}
      onProviderDisconnected={() => setConnectedProvider(null)}
      onLogout={handleLogout}
    />
  );
}
